module.exports = __webpack_public_path__ + "care_og._jQWz.jpg";